import $ from 'jquery';
import AddBookWidget from './module/add-book-widget';
import CustomerDeviceModal from './module/customer-device-modal';
import { Accordion } from './components/accordion';
import FormSubmitWithPreview from './components/form-submit-with-preview';

(function () {
  'use strict';

  $(document).ready(function () {
    Accordion.init();
    const $sticky = $('.js__sticky');
    $sticky.sticky({
      offset: $sticky.data('offset'),
    });

    $('.js__full_text_search').dropdown({ fullTextSearch: true });

    $('.js__init-ajax-select').each(function () {
      $(this).ajaxInput();
    });

    AddBookWidget.addBook($('.address-book-select'));

    CustomerDeviceModal.init();

    FormSubmitWithPreview.init();

    $('.js__file-upload').each(function () {
      $(this).fileUpload();
    });

    $(document).prizeCategorySlugGenerator();
    $(document).prizeSlugGenerator();
    $(document).campaignSlugGenerator();
    $(document).qureIssueSlugGenerator();
    $(document).citySlugGenerator();
  });

  $('.js__copy_faq_link_to_clipboard').click(function () {
    var $temp = $('<input>');
    $('body').append($temp);
    $temp.val($(this).attr('copy_link')).select();
    document.execCommand('copy');
    $temp.remove();
  });

  if ($(window).width() < 900) {
    setTimeout(function () {
      $('#sidebar').sidebar('hide');
    }, 100);
  }

  $('.js__rules-column, .js__action-column').find('.js__add-action').remove();
  $('.js__rules-column, .js__action-column').find('*[data-form-collection="delete"]').remove();

  setTimeout(function () {
    $('.ui.dropdown.selection.search').each((index, element) => {
      const $element = $(element);
      if ($element.data('url')) {
        return;
      }
      const $select = $element.find('select');
      const options = {
        fullTextSearch: true,
      };

      if ($select.is('[data-dropdown-max-selections]')) {
        options.maxSelections = $select.data('dropdown-max-selections');
      }

      if ($select.is('[data-clearable]')) {
        options.clearable = true;
      }

      $element.dropdown(options);
    });
  }, 500);

  if (!$('.js__action-dropdown .menu').children().length) {
    $('.js__action-dropdown').remove();
  }

  $('.js__cancel-price-and-promotion-modal').on('click', e => {
    e.preventDefault();
    const $target = $(e.currentTarget);
    const url = $target.find('.button').attr('href');

    $target
      .find('.js__price-and-promotion-confirm-modal')
      .modal({
        autofocus: false,
        closable: false,
        onApprove: () => {
          window.location.replace(url);
        },
      })
      .modal('show');
  });

  $('.js__reset-filters').on('click', e => {
    const $target = $(e.currentTarget);
    const $form = $target.parents('form');

    e.preventDefault();

    $form.find('input, select').each((index, item) => {
      const $item = $(item);
      if ($item.is('input')) {
        $item.val('');
      } else if ($item.is('select')) {
        $item.dropdown('clear');
      }
    });

    $form.submit();
  });

  const $campaignTypeSelect = $('.js__campaign_toggle');

  $campaignTypeSelect.on('change', e => campaignToggle($(e.currentTarget).val()));
  $('.js__campaign-external, .js__campaign-internal').attr('disabled', true).closest('.field').addClass('disabled');
  campaignToggle($campaignTypeSelect.val());

  function campaignToggle(value) {
    const isInternal = value === 'internal';
    $('.js__relations-tab').toggleClass('disable-all-fields disabled', !isInternal);
    $('.js__campaign-external').attr('disabled', isInternal).closest('.field').toggleClass('disabled', isInternal);

    $('.js__campaign-internal').attr('disabled', !isInternal).closest('.field').toggleClass('disabled', !isInternal);
    $('.summernote-editor.internal').next().toggleClass('disabled-field', !isInternal);
    $('.js__selected-sort-item-list').find('input, select').attr('disabled', !isInternal);
    $('.js__campaign-internal.ui.dropdown').toggleClass('disabled', !isInternal);
  }

  $('.js__date-input').prepend('<i class="calendar times outline icon js__clear-date"></i>');

  $('.js__clear-date').on('click', e => {
    $(e.currentTarget).next().val('YYYY-MM-DD');
    $(e.currentTarget).next().next().find('[name*="[validFrom][time]"]').dropdown('clear');
  });

  $('[type="date"]').on('click', e => {
    if ('showPicker' in HTMLInputElement.prototype) {
      e.currentTarget.showPicker();
    }
  });

  $('.js__loadable-form .js__loadable-form-button').on('click', event => {
    $(event.currentTarget).closest('.js__loadable-form').addClass('loading');
  });
})();
